

export function jwtDecode(token) {
  //return JSON.parse(atob(token.split('.')[1]))
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const buffer = Buffer.from(base64, 'base64').toString('ascii');
  const payload = JSON.parse(buffer);
  return payload
}